import { useTranslation } from 'react-i18next';

import { computeFreeTradeNotional } from 'components/trade_fee_credits/free_trade_notional';
import {
  FRESHDESK_DECODE_DELTA_CASH_BLOG,
  IS_INDIAN_EXCHANGE,
  LANDING_PAGE_DECODE_DELTA_CASH_BLOG,
  NO_DELTA_CASH_PERCENT_GLOBAL,
  NO_DELTA_CASH_PERCENT_INDIA,
} from 'constants/constants';
import subscribe from 'HOC/subscribe';
import { spotPriceSelectorBySymbol } from 'selectors/priceSelectors';
import { balanceBySymbolSelector } from 'selectors/walletSelector';
import { useAppSelector } from 'storeHooks';
import { LearnMoreIcon } from 'styles/assets/icons';

import styles from './index.module.scss';

const deltaCashPercent = IS_INDIAN_EXCHANGE
  ? NO_DELTA_CASH_PERCENT_INDIA
  : NO_DELTA_CASH_PERCENT_GLOBAL;

const learnMoreRedirectLink = IS_INDIAN_EXCHANGE
  ? FRESHDESK_DECODE_DELTA_CASH_BLOG
  : LANDING_PAGE_DECODE_DELTA_CASH_BLOG;

const getPreciseFeeCreditsForIndianExchange = balancesBySymbol => {
  const feeCreditsUSD = balancesBySymbol.USD.trading_fee_credit_precise;

  return [0, 0, feeCreditsUSD];
};

const getPreciseFeeCredits = balancesBySymbol => {
  let feeCreditsBTC = balancesBySymbol?.BTC?.trading_fee_credit_precise ?? 0;
  let feeCreditsUSDC = balancesBySymbol?.USDC?.trading_fee_credit_precise ?? 0;
  const feeCreditsUSDT = balancesBySymbol?.USDT?.trading_fee_credit_precise ?? 0;
  const feeCreditsUSD = balancesBySymbol?.USD?.trading_fee_credit_precise ?? 0;

  if (IS_INDIAN_EXCHANGE) {
    feeCreditsBTC = 0;
    feeCreditsUSDC = 0;
  }

  return [
    feeCreditsBTC,
    feeCreditsUSDC,
    !IS_INDIAN_EXCHANGE ? feeCreditsUSDT : feeCreditsUSD,
  ];
};

const TradeFeeContent = subscribe(() => {
  const { t } = useTranslation(['trading', 'common']);

  const balancesBySymbol = useAppSelector(balanceBySymbolSelector);
  const BTCSpotPrice = spotPriceSelectorBySymbol('.DEXBTUSD');

  const [feeCreditsBTC, feeCreditsUSDC, feeCreditsUSDT] = IS_INDIAN_EXCHANGE
    ? getPreciseFeeCreditsForIndianExchange(balancesBySymbol)
    : getPreciseFeeCredits(balancesBySymbol);

  const computedValue = computeFreeTradeNotional(
    feeCreditsBTC,
    feeCreditsUSDC,
    feeCreditsUSDT,
    BTCSpotPrice
  );

  if (computedValue > 1) {
    return (
      (<div className={styles.freeTradingValue} data-palette="TradeFeeContent">
        {t('trading:makerTaker.freeTrading', {
          computedValue: computedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          percent: deltaCashPercent,
        })}
      </div>)
    );
  }

  return (
    (<div className={styles.noDeltaCash} data-palette="TradeFeeContent">
      {t('trading:makerTaker.noDeltaCash', { percent: deltaCashPercent })}
      <div className={styles.learnMoreLink}>
        <a
          href={learnMoreRedirectLink}
          data-testid="offers-page"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('common:learnMore')}
          <LearnMoreIcon className={styles.learnMoreIcon} />
        </a>
      </div>
    </div>)
  );
});

export default TradeFeeContent;
export { getPreciseFeeCredits, getPreciseFeeCreditsForIndianExchange };
